import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";

import { mdiCheckCircleOutline } from "@mdi/js";

import { DffPdfFremviserModule } from "@dffedb/pdf";
import { DffSideModule, EmptyPageBadgeModule } from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";

import { FakturagodkendelseListeComponent } from "./fakturagodkendelse-liste/fakturagodkendelse-liste.component";
import { FakturagodkendelseModalComponent } from "./fakturagodkendelse-modal/fakturagodkendelse-modal.component";
import { FakturagodkendelseModal } from "./fakturagodkendelse-modal/fakturagodkendelse.modal";
import { FakturagodkendelseRoutingModule } from "./fakturagodkendelse-routing.module";
import { FakturagodkendelseComponent } from "./fakturagodkendelse/fakturagodkendelse.component";

@NgModule({
    imports: [
        CommonModule,
        DffSideModule,
        EmptyPageBadgeModule,
        FakturagodkendelseRoutingModule,
        FormsModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        DffPdfFremviserModule,
        ReactiveFormsModule
    ],
    declarations: [FakturagodkendelseListeComponent, FakturagodkendelseComponent, FakturagodkendelseModalComponent],
    providers: [
        FakturagodkendelseModal /* FakturagodkendelseModal skal provides her og ikke i 'root' for at kunne åbne lazy loaded komponent */
    ]
})
export class EForsyningFeaturesFakturagodkendelseModule {
    constructor(svgIconRegistry: SvgIconRegistry) {
        svgIconRegistry.registerIcon(mdiCheckCircleOutline, "fakturagodkendelse", "check-circle-outline");
    }
}
